/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UICustomizationChallengeOptions } from './UICustomizationChallengeOptions';
import {
    UICustomizationChallengeOptionsFromJSON,
    UICustomizationChallengeOptionsFromJSONTyped,
    UICustomizationChallengeOptionsToJSON,
    UICustomizationChallengeOptionsToJSONTyped,
} from './UICustomizationChallengeOptions';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface UICustomizationChallenge
 */
export interface UICustomizationChallenge {
    /**
     * 
     * @type {string}
     * @memberof UICustomizationChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof UICustomizationChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof UICustomizationChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {UICustomizationChallengeOptions}
     * @memberof UICustomizationChallenge
     */
    options?: UICustomizationChallengeOptions;
}



/**
 * Check if a given object implements the UICustomizationChallenge interface.
 */
export function instanceOfUICustomizationChallenge(value: object): value is UICustomizationChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function UICustomizationChallengeFromJSON(json: any): UICustomizationChallenge {
    return UICustomizationChallengeFromJSONTyped(json, false);
}

export function UICustomizationChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UICustomizationChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : UICustomizationChallengeOptionsFromJSON(json['options']),
    };
}

export function UICustomizationChallengeToJSON(json: any): UICustomizationChallenge {
    return UICustomizationChallengeToJSONTyped(json, false);
}

export function UICustomizationChallengeToJSONTyped(value?: UICustomizationChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': UICustomizationChallengeOptionsToJSON(value['options']),
    };
}

